package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.series.SimpleInstructionSeriesDto
import com.exura.features.plandefinition.domain.model.series.SimpleInstructionSeries
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Mapper for converting between SimpleInstructionSeries domain model and DTO.
 * Implements BaseSeriesMappers for Firebase storage compatibility.
 */
class SimpleInstructionSeriesMappers : BaseSeriesMappers<SimpleInstructionSeries, SimpleInstructionSeriesDto> {
    override fun toDto(model: SimpleInstructionSeries): SimpleInstructionSeriesDto = SimpleInstructionSeriesDto(
        name = model.title,
        description = model.description,
        seriesType = model.seriesSpawnType,
        durationInDays = model.durationInDays(),
        relativeDay = model.relativeDay,
        spawnForDays = model.spawnForDays,
        spawnCount = model.spawnCount,
        instruction = model.instruction,
        estimatedMinutes = model.estimatedMinutes,
        partsOfDay = model.partsOfDay,
        exactTimes = model.exactTimes,
        imageUrl = model.imageUrl,
        spawnEveryDays = model.spawnEveryDays,
    )

    override fun toDomain(dto: SimpleInstructionSeriesDto, collection: CollectionReference?, id: String?): SimpleInstructionSeries = SimpleInstructionSeries(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        title = dto.name,
        description = dto.description,
        relativeDay = dto.relativeDay,
        spawnForDays = dto.spawnForDays,
        spawnCount = dto.spawnCount,
        instruction = dto.instruction,
        estimatedMinutes = dto.estimatedMinutes,
        partsOfDay = dto.partsOfDay,
        exactTimes = dto.exactTimes,
        imageUrl = dto.imageUrl,
        spawnEveryDays = dto.spawnEveryDays,
        elements = emptyList() // Elements would be loaded separately
    )
}
